import { render, staticRenderFns } from "./HouseEdit.vue?vue&type=template&id=18101ec4&scoped=true&"
import script from "./HouseEdit.vue?vue&type=script&lang=js&"
export * from "./HouseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18101ec4",
  null
  
)

export default component.exports